export default __webpack_public_path__ + "static/media/Barclays.4c59197b.svg";